export const COMPANY = {
  name: "Zawix Business Consultants",
  tagline: "Complete Business Setup & Compliance Solutions",
  motto: "Your Growth, Our Compliance. Your Success, Our Commitment.",
  phone: "051-8488835",
  phoneHref: "tel:0518488835",
  phones: [
    { label: "Call", number: "051-8488835", href: "tel:0518488835" },
  ],
  whatsapp: "0300-5622443",
  whatsappHref: "https://wa.me/923005622443",
  whatsappContact: {
    label: "WhatsApp",
    number: "0300-5622443",
    href: "https://wa.me/923005622443",
  },
  whatsappNumbers: [
    { type: "whatsapp", number: "0300-5622443", href: "https://wa.me/923005622443" },
    { type: "whatsapp", number: "0345-3995483", href: "https://wa.me/923453995483" },
    { type: "call", number: "0315-2628529", href: "tel:03152628529" },
  ],
  email: "info@zawixbusinessconsultants.com",
  emailHref: "mailto:info@zawixbusinessconsultants.com",
  facebookUrl: "https://www.facebook.com/share/1Axq462wMY/",
  addressLines: [
    "Office No. 206, 2nd Floor",
    "Royal Centre, Blue Area",
    "Islamabad, Pakistan",
  ],
  fullAddress:
    "Office No. 206, 2nd Floor, Royal Centre, Blue Area, Islamabad, Pakistan",
  officeLabel: "Royal Centre, Blue Area, Islamabad",
  offices: [
    {
      name: "Head Office - Islamabad",
      lines: ["Office No. 206, 2nd Floor, Royal Centre, Blue Area, Islamabad"],
    },
    {
      name: "Lahore Office",
      lines: ["Office No. 11-B, 1st Floor, Allama Iqbal Town, Lahore"],
    },
    {
      name: "Karachi Office",
      lines: [
        "Office No. A11, KDA Overseas Apartments, Block-13, Gulshan-e-Iqbal, Karachi",
      ],
    },
  ],
  workingHours: [
    "Monday to Friday: 9:00 AM - 6:00 PM",
    "Saturday: By Appointment",
    "Sunday: Closed",
  ],
};

export const CLIENTS = [
  "China State Construction (CSCEC)",
  "CGGC",
  "MCC",
  "ENKA",
  "ZKB Engineers & Constructors",
  "Astral",
  "SKB Engineering & Construction",
  "Makson",
  "Habib Construction Services",
  "Metropole Construction",
  "Shahid & Company",
  "Al Saeed Construction",
];

export const HOME_HERO = {
  eyebrow: "Trusted Business Consultants Since 2015",
  title: "Welcome to Zawix Business Consultants",
  description:
    "Zawix Business Consultants has been helping businesses across Pakistan since 2015. We handle company registration, taxes, PEC licensing, audits, and other government paperwork, so you don't have to. We explain everything in plain language, keep you updated, and make sure your business stays fully legal and compliant.",
  primaryCta: { label: "Learn More", href: "/about" },
  secondaryCta: { label: "Our Services", href: "/services" },
};

export const HOME_WHAT_WE_DO = [
  {
    id: 1,
    icon: "flaticon-briefcase",
    href: "/services/secp-services",
    title: "Company Registration",
    buttonLabel: "Learn More",
    list: [
      "SECP Company Registration",
      "Private Limited & Single Member Companies",
      "LLP Registration & Annual Filing",
    ],
  },
  {
    id: 2,
    icon: "flaticon-taxes",
    href: "/services/pec-services",
    title: "PEC Consultancy",
    buttonLabel: "Learn More",
    list: [
      "New PEC Firm Registration",
      "PEC Renewal & Category Upgrade",
      "Specialization Codes & Foreign Firm Registration",
    ],
  },
  {
    id: 3,
    icon: "flaticon-money",
    href: "/services/fbr-services",
    title: "Tax & Audit Support",
    buttonLabel: "Learn More",
    list: [
      "NTN & Sales Tax Registration",
      "Income Tax Filing & Active Taxpayer Status",
      "Audit Reports & Financial Statements",
    ],
  },
  {
    id: 4,
    icon: "flaticon-layers",
    href: "/services/trademark-registration",
    title: "Licensing & Approvals",
    buttonLabel: "Learn More",
    list: [
      "Import & Export License",
      "Trademark Registration",
      "PSQCA, AEDB & Other Approvals",
    ],
  },
];

export const HOME_FEATURES = [
  {
    id: 1,
    icon: "flaticon-puzzle-piece",
    title: "Complete Business Setup",
    subtitle:
      "We help you start and run your business the right way. From registering your company to staying compliant every year, we take care of the paperwork so you don't have to worry about it.",
  },
  {
    id: 2,
    icon: "flaticon-inspiration",
    title: "Experienced Team",
    subtitle:
      "Our consultants have years of hands-on experience with SECP, FBR, PEC, and other government departments. We know the process well, so your work gets done correctly the first time.",
  },
  {
    id: 3,
    icon: "flaticon-profit",
    title: "Taxation Made Easy",
    subtitle:
      "Taxes can be confusing, but we make them simple. We explain what you owe, file your returns on time, and help you stay on the FBR's active taxpayer list without stress.",
  },
  {
    id: 4,
    icon: "flaticon-handshake",
    title: "Government Approvals Simplified",
    subtitle:
      "Dealing with government offices takes time and patience. We prepare your documents, submit your application, and follow up until you get your approval, so you don't have to visit any office yourself.",
  },
  {
    id: 5,
    icon: "flaticon-layers",
    title: "Offices in Three Cities",
    subtitle:
      "We have offices in Islamabad, Lahore, and Karachi, so we can support clients across Pakistan. Wherever your business is based, our team is ready to help.",
  },
  {
    id: 6,
    icon: "flaticon-rocket",
    title: "Fast & Reliable Service",
    subtitle:
      "We value your time. Our team works quickly and keeps you updated at every step, so your registration or approval moves forward without unnecessary delays.",
  },
];

export const HOME_EXPERTISE = {
  eyebrow: "Our Expertise",
  title: "One team for all your business registration and compliance needs",
  description:
    "You don't need to deal with many different offices on your own. We work with SECP, FBR, PEC, and other government departments every day, so we know exactly what is needed and how to get it done quickly.",
  checklist: [
    "SECP Company Registration & Yearly Compliance",
    "PEC Registration for Engineering & Construction Firms",
    "FBR Tax Registration & Filing",
    "Import & Export Licensing",
    "Trademark Registration & Other Government Approvals",
  ],
  stats: [
    { value: "10+", label: "Years of experience" },
    { value: "1000s", label: "Clients served nationwide" },
  ],
};

export const HOME_COUNTERS = [
  { id: 1, count: 10, suffix: "+", title: "Years Serving Pakistan" },
  { id: 2, count: 1000, suffix: "+", title: "Clients Served" },
  { id: 3, count: 3, suffix: "", title: "Offices Across Pakistan" },
  { id: 4, count: 100, suffix: "%", title: "Client-First Focus" },
];

export const HOME_FAQ = {
  eyebrow: "Why Choose Zawix",
  title: "Simple, reliable help with registration, taxes, and approvals",
  description:
    "Businesses choose Zawix because we explain things clearly, handle the paperwork, and follow up until the job is done.",
  items: [
    {
      question: "Why do businesses work with Zawix?",
      answer:
        "Because we take care of registration, taxes, compliance, and approvals under one roof, and we guide you through every step in simple language.",
    },
    {
      question: "Do you work with international companies as well?",
      answer:
        "Yes. We have worked with many local businesses as well as international companies from China, Turkey, Dubai, and other countries.",
    },
    {
      question: "What makes your approach different?",
      answer:
        'Our motto is "Your Growth, Our Compliance. Your Success, Our Commitment." We keep things clear, honest, and on time so you can move forward with confidence.',
    },
  ],
};

export const ABOUT_PAGE = {
  intro:
    "Zawix Business Consultants (Pvt.) Ltd. was started in 2015. We are one of Pakistan's growing consultancy firms, and we help businesses with company registration, taxes, engineering consultancy, compliance, audits, licensing, and other government approvals. Over the years, we have helped thousands of clients across the country.",
  introTwo:
    "We offer complete business setup and compliance support under one roof for contractors, engineering firms, construction companies, startups, manufacturers, solar companies, import and export businesses, and other corporate organizations. Our motto is simple: \"Your Growth, Our Compliance. Your Success, Our Commitment.\"",
  mission:
    "Our mission is to make business registration and compliance simple. We offer expert advice, handle your documents, and provide friendly, customer-focused service so you can focus on growing your business.",
  vision:
    "Our vision is to become Pakistan's most trusted and innovative consultancy firm by offering professional, honest, and reliable business services all across the country.",
  coreValues: [
    {
      title: "Customer Comes First",
      text: "Your needs always come first with us.",
    },
    {
      title: "Clarity",
      text: "We explain every process in plain, simple language so you always know what's happening.",
    },
    {
      title: "Reliability",
      text: "We do our work on time, accurately, and with full follow-up until it's done.",
    },
    {
      title: "Confidentiality",
      text: "We keep your business information private and secure at all times.",
    },
  ],
  whyChoose: [
    "Established Professional Consultancy Firm Since 2015",
    "Thousands of Satisfied Clients Nationwide",
    "Professional & Experienced Team",
    "Fast & Hassle-Free Processing",
    "Transparent Communication at Every Step",
    "Complete Documentation Support",
    "Offices in Islamabad, Lahore & Karachi",
    "Long-Term Client Relationships",
  ],
  recognition:
    "Zawix Business Consultants is a fully compliant and recognized consultancy firm. Our client companies hold certifications such as ISO 9001:2015 (Quality Management) and ISO 14001:2015 (Environmental Management), along with FBR AML/CFT registration, giving you extra confidence when you work with us.",
};

export const SERVICE_OVERVIEW = {
  intro:
    "At Zawix Business Consultants, we offer a full range of services to help your business get registered and stay compliant with Pakistani law. Whether you're a small startup or a large company, our team can guide you through the process in simple steps.",
  categories: [
    "SECP Company Registration",
    "PEC Consultancy Services",
    "FBR & Tax Consultancy",
    "Audit & Financial Consultancy",
    "Import & Export Licensing",
    "Trademark & Regulatory Approvals",
  ],
};

export const SERVICES = [
  {
    id: 1,
    slug: "secp-services",
    icon: "flaticon-business-presentation",
    navTitle: "SECP Registration",
    title: "SECP Registration",
    shortTitle: "Complete SECP Company Registration Services",
    pageTitle: "SECP Registration",
    cardText:
      "From first consultation to final approval, we manage the complete SECP registration process with careful documentation, compliant filing, and practical post-registration support.",
    intro:
      "Zawix Business Consultants handles your complete SECP company registration from start to finish. We prepare your documents, file them with SECP, and support you after registration too, so the whole process is smooth and stress-free.",
    overviewTitle: "What We Handle For Your SECP Registration",
    overviewItems: [
      [
        "Document Preparation",
        "We prepare all the documents you need for SECP, including the Memorandum of Association, Articles of Association, and other required paperwork.",
      ],
      [
        "SECP Filing",
        "We file everything with SECP online, double-check the forms, and follow up until your registration is approved.",
      ],
      [
        "Post-Registration Support",
        "After your company is registered, we help with yearly filings, compliance, and any changes your business needs later on.",
      ],
    ],
    offersTitle: "SECP Registration Services",
    offers: [
      ["Company Registration Services", "We register Private Limited Companies, Single Member Companies, Public Limited Companies, NGOs, foreign companies, and Limited Liability Partnerships."],
      ["Name Reservation & Availability Check", "We check if your company name is available, reserve it with SECP, and make sure it follows SECP's naming rules."],
      ["Preparation of Incorporation Documents", "We prepare the Memorandum of Association, Articles of Association, and all the required forms and declarations."],
      ["Online SECP Filing (e-Services)", "We set up your SECP e-Services account and file all your incorporation forms online, including digital signatures where needed."],
      ["Changes in Company Structure or Information", "We help with adding or removing directors, changing your address, changing your capital, renaming your company, or converting company type."],
      ["Annual Compliance Filing", "We handle your annual returns, statutory forms, audited accounts, and keep your company records up to date."],
      ["SECP License & Certification Assistance", "We also help with special licenses like Section 42 licensing and support for insurance, leasing, and microfinance companies."],
    ],
    highlightsTitle: "Why Choose Zawix for SECP Registration?",
    highlights: [
      "An experienced team that knows SECP rules and procedures well",
      "Most standard registrations are completed in 15 to 20 working days",
      "We focus on accuracy so your registration goes through without avoidable issues",
    ],
    processDuration: "15-20 Working Days",
    processTitle: "Our SECP Registration Process",
    processSubtitle:
      "A streamlined 6-step process designed to make company registration smooth, efficient, and fully compliant.",
    processSteps: [
      [
        "Initial Consultation",
        "We review your business requirements, proposed structure, and registration objectives, then guide you on the most suitable SECP registration route.",
      ],
      [
        "Document Collection",
        "We collect and review CNICs, address verification, business details, and any supporting information needed for incorporation.",
      ],
      [
        "Document Preparation",
        "Our team prepares the MOA, AOA, declarations, and supporting documents in line with SECP requirements and your business structure.",
      ],
      [
        "SECP Filing",
        "We submit the application through the SECP portal and manage follow-ups, queries, and communication with the regulator.",
      ],
      [
        "Approval & Registration",
        "Once approved, we complete the registration and provide you with the incorporation documents and relevant certificates.",
      ],
      [
        "Post-Registration Support",
        "We remain available for annual compliance, statutory changes, and ongoing support after your company is registered.",
      ],
    ],
    documentGroups: [
      [
        "Identity Documents",
        [
          "CNIC copies of all directors",
          "Passport copies where applicable",
          "Recent photographs",
        ],
      ],
      [
        "Business Information",
        [
          "Three company name options",
          "Business objectives",
          "Registered office address",
          "Share capital structure",
        ],
      ],
      [
        "Additional Requirements",
        [
          "Bank reference letter",
          "Utility bills for address verification",
          "Professional qualifications where applicable",
        ],
      ],
    ],
  },
  {
    id: 2,
    slug: "boi-registration",
    icon: "flaticon-mission",
    navTitle: "BOI Registration",
    title: "BOI Registration",
    shortTitle: "BOI Registration 2025 - Complete Guide",
    pageTitle: "BOI Registration 2025 - Complete Guide",
    cardText:
      "Comprehensive support for businesses seeking Board of Investment registration, investment incentives, and streamlined approvals in Pakistan.",
    intro:
      "The Board of Investment (BOI) is Pakistan's main agency for attracting local and foreign investment. Getting registered with BOI can give you access to tax breaks, faster approvals, and other benefits if your project qualifies.",
    overviewTitle: "Comprehensive BOI Services",
    overviewItems: [
      [
        "Investment Proposal",
        "We prepare your investment proposal and feasibility study in the format BOI expects.",
      ],
      [
        "Documentation & Filing",
        "We prepare your documents, file your application, and follow up with BOI until it's processed.",
      ],
      [
        "Incentive Management",
        "We help you understand and use the incentives you qualify for, and support you with renewals when needed.",
      ],
    ],
    offersTitle: "Our BOI Registration Services",
    offers: [
      [
        "Eligibility Assessment & Project Evaluation",
        "We check whether your project qualifies for BOI registration and suggest the best way forward.",
      ],
      [
        "Investment Proposal Preparation",
        "We prepare your investment proposal, project summary, and supporting documents for BOI's review.",
      ],
      [
        "Application Submission & Follow-Up",
        "We submit your application and stay in touch with BOI until you get a response.",
      ],
      [
        "Incentive Package Guidance",
        "We explain which tax breaks and benefits apply to your project.",
      ],
      [
        "Compliance Monitoring & Reporting",
        "We help you meet any reporting requirements after your registration is approved.",
      ],
      [
        "Post-Registration Support & Renewals",
        "We stay available to help with renewals and any compliance questions after registration.",
      ],
    ],
    highlightsTitle: "Benefits of BOI Registration",
    highlights: [
      "Possible tax breaks and lower import duties on eligible equipment",
      "Faster approvals through BOI's facilitation support",
      "Access to special economic zones and industrial parks, where applicable",
      "One-window support for your investment",
      "Better credibility with international investors and partners",
      "Improved chances for selected government projects",
    ],
    noteTitle: "Eligibility Criteria",
    note:
      "BOI registration is usually relevant for manufacturing, infrastructure, IT, renewable energy, and export-focused businesses, as well as other larger service-sector investments that meet the required conditions.",
    processDuration: "100+ BOI Registrations Supported",
    processTitle: "BOI Registration Process",
    processSubtitle:
      "Our streamlined 5-step process is designed to make BOI registration efficient, well-documented, and easier to navigate.",
    processSteps: [
      [
        "Initial Consultation",
        "We look at your project and tell you whether it's a good fit for BOI registration.",
      ],
      [
        "Documentation",
        "We prepare your investment proposal and all supporting documents.",
      ],
      [
        "Application Submission",
        "We submit your BOI application with all the required attachments.",
      ],
      [
        "Review & Follow-Up",
        "We track your application and follow up with BOI during the review.",
      ],
      [
        "Approval & Handover",
        "Once approved, we hand over your registration documents and explain the next steps.",
      ],
    ],
    documentGroups: [
      [
        "Company Documents",
        [
          "Certificate of Incorporation",
          "Memorandum & Articles of Association",
          "Board Resolution for BOI Registration",
          "Company Profile and Business Plan",
          "Financial Statements and Projections",
        ],
      ],
      [
        "Project Documents",
        [
          "Detailed Project Feasibility Study",
          "Technical Specifications and Equipment List",
          "Environmental Impact Assessment where applicable",
          "Investment Plan and Funding Sources",
          "Market Analysis and Business Strategy",
        ],
      ],
      [
        "Supporting Documents",
        [
          "Tax Registration Certificates",
          "Bank Statements and evidence of financial capacity",
          "Professional Certifications",
          "Previous Project Experience",
          "Partnership Agreements where applicable",
        ],
      ],
    ],
  },
  {
    id: 3,
    slug: "pec-services",
    icon: "flaticon-rocket",
    navTitle: "PEC Registration",
    title: "PEC Registration",
    shortTitle: "PEC Registration Process",
    pageTitle: "PEC Registration Process",
    cardText:
      "We help you get your PEC registration, renewal, or upgrade done correctly, with all documents prepared and submitted for you.",
    intro:
      "Zawix Business Consultants offers complete PEC (Pakistan Engineering Council) registration services for engineers, consulting firms, construction companies, and foreign firms working in Pakistan. This includes new firm registration, renewals, category upgrades, specialization codes, and foreign firm registration. We prepare your documents, submit your application, and follow up with PEC until your certificate is issued.",
    overviewTitle: "PEC Registration Process",
    overviewItems: [
      [
        "Document Preparation",
        "We help you prepare your certificates, experience letters, and other documents needed for PEC.",
      ],
      [
        "Application Processing",
        "We fill in your forms correctly and submit them under the right PEC category.",
      ],
      [
        "Registration Approval",
        "We follow up with PEC until your registration is approved and your certificate is issued.",
      ],
    ],
    offersTitle: "Our PEC Registration Services",
    offers: [
      [
        "New Registration",
        "We help construction and engineering firms get a new PEC registration, in any category from C-6 to CA and O6 to OA.",
      ],
      [
        "PEC License Renewal",
        "We handle your renewal on time so your registration doesn't lapse.",
      ],
      [
        "Consultant Firm Registration & Renewal",
        "Whether you're registering a new consulting firm or renewing an existing one, we handle the paperwork and filing for you.",
      ],
      [
        "Foreign Company Registration & Renewal",
        "We help foreign engineering companies register and renew under the right PEC category to work in Pakistan.",
      ],
      [
        "Upgradation of PEC License",
        "If you're ready to move up to a higher PEC category, we manage the upgrade process from start to finish.",
      ],
      [
        "Specialized PEC Codes",
        "We help you get the right specialization codes for your engineering field.",
      ],
    ],
    highlightsTitle: "Why Choose Our PEC Registration Services?",
    highlights: [
      "A team that knows PEC's rules and categories well",
      "Fast handling of documents, submissions, and follow-ups",
      "Careful checking of your file to avoid errors and delays",
    ],
    noteTitle: "PEC Registration Benefits",
    note:
      "PEC registration is required for engineers and firms who want to work legally in the engineering field, bid for projects, and maintain good standing with the Pakistan Engineering Council.",
    processTitle: "PEC Registration Requirements",
    processSubtitle:
      "Understanding the documentation and qualification requirements is essential for a successful PEC application.",
    documentGroups: [
      [
        "Educational Documents",
        [
          "Engineering Degree Certificate",
          "Transcripts or mark sheets",
          "Provisional Certificate where applicable",
        ],
      ],
      [
        "Personal Documents",
        [
          "CNIC copy",
          "Passport size photographs",
          "Updated CV or resume",
        ],
      ],
      [
        "Professional Documents",
        [
          "Experience letters",
          "Project portfolio",
          "Professional references",
        ],
      ],
    ],
  },
  {
    id: 4,
    slug: "additional-services",
    icon: "flaticon-mission",
    navTitle: "Additional Services",
    title: "Additional Services",
    shortTitle: "Government Enlistments, Approvals & Specialized Registrations",
    pageTitle: "Additional Services - Government Enlistments, Approvals & Specialized Registrations",
    cardText:
      "Stepping into the world of renewable energy and government approvals? We cover all additional registration and licensing services that modern businesses need to operate effectively.",
    intro:
      "Besides our main services, Zawix also helps with government department enlistments, special registrations, and other compliance needs. These are often required for businesses in construction, government contracting, and other regulated sectors.",
    offersTitle: "What We Offer Under Additional Services",
    offers: [
      ["C&W (Communication & Works) Department Enlistment", "Construction companies working on government projects need to be enlisted with the C&W Department. We handle the paperwork and submission for you."],
      ["PWD (Public Works Department) Enlistment", "We help you get and keep your PWD enlistment so you can bid on government construction projects."],
      ["CDA (Capital Development Authority) Enlistment", "If you want to work on construction projects in Islamabad, you need CDA enlistment. We manage the application and renewal for you."],
      ["KPRA (Khyber Pakhtunkhwa Revenue Authority) Registration", "If your business operates in KP, you need to register with KPRA for sales tax on services. We handle registration, filing, and compliance."],
      ["PPRA (Public Procurement Regulatory Authority) Registration", "Companies bidding on federal contracts need PPRA registration. We help you get registered and stay compliant."],
      ["Excise & Taxation Registration", "We help with excise duty registration, vehicle excise, and other provincial tax requirements."],
      ["Partnership Deed Drafting", "We draft a clear, legally sound Partnership Deed that spells out profit sharing, responsibilities, and how disputes are handled."],
      ["Joint Venture (JV) Agreements", "For projects where two or more companies work together, we draft a JV agreement that protects everyone's interests."],
      ["Professional Audit Reports & Business Profiles", "We prepare audited financial statements and business profiles that meet the standards banks, government offices, and partners expect."],
      ["Trade License & Local Government Registrations", "We help you get trade licenses and other local government registrations wherever your business operates."],
      ["Chamber of Commerce Membership", "We help you apply for membership in your city or regional Chamber of Commerce."],
      ["Brand & Trademark Registration", "We help you register your brand name and logo with IPO-Pakistan to protect it legally. See our dedicated Trademark Registration page for details."],
    ],
    noteTitle: "Why These Services Matter",
    note:
      "Many businesses miss out on major contracts simply because they're missing the right enlistment or registration. Our additional services make sure your company is fully ready to take on government projects and stay compliant everywhere it operates.",
  },
  {
    id: 5,
    slug: "aedb-services",
    icon: "flaticon-inspiration",
    navTitle: "AEDB / PPIB Registration",
    title: "AEDB / PPIB Registration",
    shortTitle: "AEDB / PPIB Solar Company Registration 2025 - Complete Guide",
    pageTitle: "AEDB / PPIB Solar Company Registration 2025 - Complete Guide",
    cardText:
      "Practical support for solar importers, vendors, and installers seeking AEDB / PPIB registration for net metering and renewable energy project eligibility.",
    intro:
      "AEDB (now part of PPIB) registration is for solar importers, vendors, and installers. It shows that your company is technically capable and financially sound, which helps with net-metering work and bigger solar projects.",
    overviewTitle: "Comprehensive AEDB / PPIB Services",
    overviewItems: [
      [
        "Documentation & Filing",
        "We prepare all the forms and documents you need, and submit them on your behalf.",
      ],
      [
        "Compliance Management",
        "We help you keep your registration up to date and guide you through renewals.",
      ],
      [
        "Expert Consultation",
        "We give you practical advice from people who know the renewable energy sector well.",
      ],
    ],
    contentSections: [
      [
        "What Is AEDB / PPIB Registration?",
        "It's an official approval for companies working in solar, wind, and hybrid energy. It's usually needed for net-metering work, large installations, and many government-backed energy projects.",
      ],
      [
        "What Is Net Metering?",
        "Net metering lets solar users send extra electricity back to the grid through a special meter. You get credit for the extra power you supply.",
      ],
      [
        "Why Registration Matters",
        "It proves your company's technical ability, helps you get on vendor lists for bigger tenders, and builds trust with banks and institutional buyers.",
      ],
    ],
    offersTitle: "How to Apply & Our Services",
    offers: [
      [
        "Eligibility Assessment & Category Selection",
        "We look at your solar business and help you pick the right registration category.",
      ],
      [
        "Document Preparation",
        "We prepare the technical, financial, and legal documents AEDB / PPIB requires.",
      ],
      [
        "Form Filling & Submission",
        "We fill in your application accurately and submit it for you.",
      ],
      [
        "Bank Guarantee Assistance",
        "We help you understand and prepare the bank guarantee, where required.",
      ],
      [
        "Authority Follow-Up",
        "We stay in touch with the authorities and keep you updated until it's done.",
      ],
      [
        "Final Handover",
        "Once approved, we hand over your documents and explain what to do next.",
      ],
      [
        "C-3 Category Registration (Up to 250 kW)",
        "Good for startups and small solar contractors doing residential and small commercial projects.",
      ],
      [
        "C-2 Category Registration (Up to 500 kW)",
        "For growing solar companies moving into bigger commercial projects.",
      ],
      [
        "C-1 Category Registration (No Capacity Limit)",
        "For larger solar companies working on industrial, commercial, and utility-scale projects.",
      ],
    ],
    highlightsTitle: "Benefits of AEDB / PPIB Registration",
    highlights: [
      "Stronger market credibility",
      "Eligibility for government and donor-funded renewable energy projects",
      "Better access to bank financing for your clients",
      "More trust from commercial and institutional buyers",
      "Better chances of becoming a recognized vendor or installer",
      "Certification that stays valid for several years, depending on policy",
    ],
    noteTitle: "Why Registration Is Required",
    note:
      "This registration is usually needed to be recognized as a vendor for net-metering work, to take part in government-funded renewable energy projects, and to build trust with banks and institutional buyers.",
    feeTableTitle: "Fees, Bank Guarantee & Typical Timelines",
    feeTableNote:
      "Costs can vary by policy cycle and province. PEC registration and bank guarantees are usually charged separately. With a complete file, most cases take 4 to 6 weeks.",
    feeTable: {
      columns: ["Category", "Limit", "Indicative Cost (PKR)"],
      rows: [
        ["C-3 (3 years)", "Up to 250 kW", "Rs. 755,000"],
        ["C-2 (3 years)", "Up to 500 kW", "Rs. 1,225,000"],
        ["C-1 (3 years)", "No limit", "Rs. 1,650,000"],
      ],
    },
    extraChecklistTitle: "Requirements & PEC Codes",
    extraChecklist: [
      "A valid PEC registration in the right category, including electrical or mechanical codes where needed",
      "A company profile and business plan showing your technical ability",
      "Qualified staff, including electrical and mechanical engineers where required",
      "Audited financial statements or bank references",
      "A bank guarantee, usually refundable once conditions are met",
      "Proof of how long your company has been operating, if required for your category",
      "Relevant PEC codes such as electrical power, mechanical, civil, environmental, or mechatronics",
    ],
    scopeTitle: "Scope of Solar Business & Registered Vendors",
    scopeText:
      "Pakistan's solar market keeps growing across homes, businesses, and larger utility projects. Registered vendors are usually in a stronger position for on-grid installations and institutional contracts in cities like Islamabad, Rawalpindi, Lahore, and Karachi.",
    processDuration: "500+ Successful Registrations",
    processTitle: "AEDB Registration Process",
    processSubtitle:
      "Our streamlined 5-step process is designed to make AEDB / PPIB registration practical, complete, and easier to manage.",
    processSteps: [
      [
        "Initial Consultation",
        "We look at your company and project to figure out the right category for you.",
      ],
      [
        "Document Collection",
        "We gather and check all the technical, legal, and financial documents you need.",
      ],
      [
        "Application Filing",
        "We prepare and submit your application with all the supporting documents.",
      ],
      [
        "Follow-Up & Updates",
        "We follow up regularly and keep you updated during the review.",
      ],
      [
        "Approval & Handover",
        "Once approved, we hand over your documents and explain what's next.",
      ],
    ],
    documentGroups: [
      [
        "Company Documents",
        [
          "Certificate of Incorporation",
          "Memorandum & Articles of Association",
          "Board Resolution for AEDB / PPIB Registration",
          "Company Profile and Business Plan",
        ],
      ],
      [
        "Technical Requirements",
        [
          "Technical specifications and standards",
          "Quality management system information",
          "Safety and compliance certificates",
          "Technical team qualifications",
          "Relevant PEC registration and codes where applicable",
        ],
      ],
      [
        "Financial Documents",
        [
          "Audited financial statements",
          "Bank statements and references",
          "Tax registration certificates",
          "Insurance coverage documents",
          "Bank guarantee where required",
        ],
      ],
    ],
  },
  {
    id: 6,
    slug: "fbr-services",
    icon: "flaticon-calculator",
    navTitle: "FBR, NTN & Sales Tax",
    title: "FBR, NTN & Sales Tax",
    shortTitle: "Tax Registration Services",
    pageTitle: "Tax Registration Services",
    cardText:
      "We take care of your tax registration and filing, including NTN, sales tax, and staying on FBR's active taxpayer list.",
    intro:
      "Zawix Business Consultants makes tax registration simple for both individuals and businesses. We help you get your NTN, register for sales tax, file your income tax returns, and stay on the FBR active taxpayer list. We also handle PRA, KPRA, and SRB registration where needed, so you don't have to deal with the tax office yourself.",
    overviewTitle: "Core Tax Registration Services",
    overviewItems: [
      [
        "NTN Registration",
        "We register your National Tax Number with FBR, whether you're an individual or a business.",
      ],
      [
        "Sales Tax Registration",
        "We handle your federal and provincial sales tax registration, including GST and SRB where needed.",
      ],
      [
        "Tax Filing Support",
        "We help with your monthly returns, annual filing, and general tax compliance.",
      ],
    ],
    offersTitle: "Tax Registration Solutions",
    offers: [
      [
        "Individual NTN",
        "We help individuals get registered with a National Tax Number and set up their basic tax filing.",
      ],
      [
        "Business NTN",
        "We register NTN for sole proprietorships, partnerships, and companies so your business can operate formally.",
      ],
      [
        "Electronic Filing",
        "We file your applications and returns online, accurately and on time.",
      ],
      [
        "Sales Tax Registration",
        "We handle sales tax registration for federal and provincial requirements, including GST.",
      ],
      [
        "Monthly Returns",
        "We prepare and file your monthly returns and keep your records in order.",
      ],
      [
        "Annual Filing & Audit Support",
        "We help with your annual filing and support you if FBR asks for an audit.",
      ],
    ],
    highlightsTitle: "Why Choose Zawix for Tax Registration?",
    highlights: [
      "We support both individuals and businesses",
      "Practical help with NTN, sales tax, and ongoing filing",
      "Clear guidance on documents needed, so there's less chance of delay",
      "Ongoing support for your regular tax obligations",
    ],
    noteTitle: "Required Documents",
    note:
      "The documents you need can vary depending on your situation. We tell you exactly what's needed before you submit, so the process moves smoothly.",
    documentGroups: [
      [
        "For Individuals",
        [
          "CNIC copy (front and back)",
          "Passport size photograph",
          "Bank account details",
          "Contact information",
        ],
      ],
      [
        "For Businesses",
        [
          "Company registration certificate",
          "Directors' CNIC copies",
          "Bank statements",
          "Office address proof",
        ],
      ],
    ],
  },
  {
    id: 7,
    slug: "audit-report",
    icon: "flaticon-analytics",
    navTitle: "Audit Report",
    title: "Audit Report",
    shortTitle: "Our Audit Services",
    pageTitle: "Our Audit Services",
    cardText:
      "We prepare clear audit reports and financial statements that meet regulatory requirements, so your business stays fully compliant.",
    intro:
      "Zawix Business Consultants prepares audit reports, financial statements, project financial analysis, and revenue statements for businesses of all sizes. Whether you need a yearly statutory audit or documents for a specific purpose, our team prepares clear, accurate reports that meet regulatory requirements.",
    overviewTitle: "Audit Services We Offer",
    overviewItems: [
      [
        "Statutory Audit",
        "An independent audit report that meets the legal and regulatory standards required for your business.",
      ],
      [
        "Internal Audit",
        "A review of your internal controls to help you spot risks and run more efficiently.",
      ],
      [
        "Compliance Audit",
        "A focused check on whether you're meeting tax rules, contracts, and industry regulations.",
      ],
    ],
    offersTitle: "Deliverables & Benefits",
    offers: [
      [
        "Statutory Audit Report",
        "A professional audit report that meets the requirements for your specific assignment.",
      ],
      [
        "Management Letter",
        "A clear letter pointing out weaknesses and how to improve your controls and governance.",
      ],
      [
        "Follow-Up on Remedial Actions",
        "We help you review the fixes you've made and plan the next steps after the audit.",
      ],
    ],
    highlightsTitle: "Why Businesses Use Our Audit Services",
    highlights: [
      "Audits tailored to statutory, internal, compliance, or special needs",
      "Clear reports with practical recommendations, not just generic notes",
      "Help improving your internal controls and documentation",
      "Reports that are useful for management and regulators",
    ],
    noteTitle: "What You Can Expect",
    note:
      "We give you clear findings and practical next steps, not just a list of issues, so you know exactly what to fix and why it matters.",
  },
  {
    id: 8,
    slug: "chamber-of-commerce",
    icon: "flaticon-handshake",
    navTitle: "Chamber of Commerce",
    title: "Chamber of Commerce",
    shortTitle: "Benefits of Chamber Membership",
    pageTitle: "Benefits of Chamber Membership",
    cardText:
      "Certification, trade promotion, networking events, and business support services to help your company grow.",
    intro:
      "We help businesses become members of the Chamber of Commerce, which gives you more credibility, networking opportunities, and useful business support.",
    overviewTitle: "Key Membership Benefits",
    overviewItems: [
      [
        "Networking & Trade",
        "Access to trade delegations, business meetings, and networking events.",
      ],
      [
        "Certificates & Documents",
        "Help with certificates of origin and other trade documents.",
      ],
      [
        "Business Support",
        "Updates on policy changes and access to Chamber helpdesks.",
      ],
    ],
    offersTitle: "How Chamber Membership Supports Growth",
    offers: [
      [
        "Business Credibility",
        "Membership builds trust with your customers, suppliers, and partners.",
      ],
      [
        "Trade Facilitation",
        "It gives you access to export documents and trade events.",
      ],
      [
        "Ongoing Institutional Support",
        "Chambers give you a point of contact for business concerns and updates.",
      ],
    ],
    highlightsTitle: "Why Businesses Seek Chamber Membership",
    highlights: [
      "More visibility and credibility in the business community",
      "Access to networking and trade promotion events",
      "Help with certificates, documents, and verification",
      "Access to updates and business facilitation services",
    ],
    noteTitle: "Our Support",
    note:
      "We prepare your membership documents and guide you through the application, so it moves quickly with less back-and-forth.",
  },
  {
    id: 9,
    slug: "import-export-registration",
    icon: "flaticon-global",
    navTitle: "Import / Export Registration",
    title: "Import / Export Registration",
    shortTitle: "Our Import / Export Services",
    pageTitle: "Our Import / Export Services",
    cardText:
      "We get your import export license and chamber membership sorted, along with all the customs paperwork you need to trade legally.",
    intro:
      "Zawix Business Consultants helps businesses get their import export license, register with the relevant chamber of commerce, and prepare the customs documents needed to trade internationally. We guide you through each step so you can start importing or exporting without confusion or delay.",
    overviewTitle: "Core Import / Export Services",
    overviewItems: [
      [
        "Customs Registration",
        "We help with customs registration, tariff classification, and HS code identification.",
      ],
      [
        "IE Code & Licenses",
        "We help you get your import export code and the trade licenses you need.",
      ],
      [
        "Shipping Documentation",
        "We guide you on bills of lading, certificates of origin, and customs clearance paperwork.",
      ],
    ],
    offersTitle: "How We Support Importers & Exporters",
    offers: [
      [
        "Registration & Setup",
        "We help you complete the registrations and codes you need before you start trading.",
      ],
      [
        "Document Preparation",
        "We prepare your trade documents so your applications and shipping records are ready to go.",
      ],
      [
        "Compliance Advisory",
        "We explain what documents and licenses you need at each step.",
      ],
    ],
    highlightsTitle: "Why Businesses Use This Service",
    highlights: [
      "Better preparation for customs and trade paperwork",
      "Clear guidance on IE codes, licensing, and registrations",
      "Help with shipping and customs paperwork",
      "Fewer delays caused by missing documents",
    ],
    noteTitle: "Required Documents & Steps",
    note:
      "You'll need both business and shipping documents for this registration. We help you spot anything missing before you submit.",
    documentGroups: [
      [
        "Business Documents",
        [
          "Company registration or incorporation documents",
          "NTN and tax certificates",
          "Bank account details and customs bond information",
        ],
      ],
      [
        "Operational Documents",
        [
          "Shipping agreements",
          "Warehousing and logistics contracts",
          "Product HS codes and tariff details",
        ],
      ],
      [
        "Compliance & Registration",
        [
          "Import licenses where applicable",
          "Customs clearance documents",
          "Certificates of origin",
        ],
      ],
    ],
  },
  {
    id: 10,
    slug: "income-tax-return",
    icon: "flaticon-profit",
    navTitle: "Income Tax Return",
    title: "Income Tax Return",
    shortTitle: "Income Tax Return Services in Rawalpindi & Islamabad",
    pageTitle: "Income Tax Return Services in Rawalpindi & Islamabad",
    cardText:
      "End-to-end support for NTN registration, annual income tax filing, and return submission with quick receipts and guided assistance.",
    intro:
      "We help clients in Rawalpindi and Islamabad with income tax returns. Whether you're an individual, a business, or a non-profit, we handle your NTN registration and file your annual return accurately.",
    overviewTitle: "Income Tax Return Services",
    overviewItems: [
      [
        "NTN Registration",
        "We register your NTN whether you're a salaried employee, a business, a partnership, a company, or a non-profit.",
      ],
      [
        "Annual Income Tax Filing",
        "We file your annual return whether you're salaried, self-employed, a partnership, a company, or a non-profit.",
      ],
      [
        "Payments & Accounts",
        "You can check your assessments and balances online, and we get you a filing receipt quickly.",
      ],
    ],
    offersTitle: "Avail Income Tax Advisory & Filing Services",
    offers: [
      [
        "Share Your Tax Task",
        "Send us your documents through our contact form, email, or WhatsApp, and we'll review them.",
      ],
      [
        "Receive Quote & Timeline",
        "We review your documents and give you a clear price and timeline.",
      ],
      [
        "Approve & Complete Documents",
        "Once you approve, we let you know if anything else is needed.",
      ],
      [
        "Preparation, Review & Filing",
        "We prepare your return, check it carefully, file it, and send you the receipt by email.",
      ],
    ],
    highlightsTitle: "What to Expect",
    highlights: [
      "A fast review and clear quote before we start",
      "Your documents are kept safe and private",
      "You get a receipt and confirmation after filing",
      "Every return is checked by an experienced tax consultant before filing",
    ],
    noteTitle: "Income Tax Specialists",
    note:
      "Our team reaches out quickly if anything is missing, and guides you through filing from start to finish. Every return is checked carefully before it's submitted.",
    processTitle: "Our Tax Filing Process",
    processSubtitle:
      "A simple 3-step process to keep your tax return accurate and on time.",
    processSteps: [
      [
        "Document Collection",
        "We tell you exactly what documents you need based on your situation.",
      ],
      [
        "Analysis & Preparation",
        "We review your financial information and prepare your return accurately.",
      ],
      [
        "Filing & Verification",
        "We file your return and help with verification so you get quick confirmation.",
      ],
    ],
    documentGroups: [
      [
        "For Salaried Individuals",
        [
          "Salary certificates",
          "Bank statements",
          "Investment proofs",
        ],
      ],
      [
        "For Business Owners",
        [
          "Financial statements",
          "Business registration documents",
          "Expense records",
        ],
      ],
      [
        "Common Documents",
        [
          "Color copy of CNIC",
          "NTN certificate if available",
          "Latest paid electricity bill or proof of registered address",
        ],
      ],
    ],
  },
  {
    id: 11,
    slug: "professional-tax-certificate",
    icon: "flaticon-layers",
    navTitle: "Professional Tax Certificate",
    title: "Professional Tax Certificate",
    shortTitle: "Professional Tax Certification",
    pageTitle: "Professional Tax Certification",
    cardText:
      "Expert assistance in obtaining professional tax certification and staying compliant with the relevant tax authorities.",
    intro:
      "We help businesses and professionals get their professional tax certificate. We explain what's needed, prepare your documents, and submit your application so it moves quickly.",
    overviewTitle: "Professional Tax Support",
    overviewItems: [
      [
        "Expert Assistance & Compliance",
        "We guide you through the whole certification process, including documents and coordination with the local tax authority.",
      ],
      [
        "Application Handling",
        "We prepare your forms and organize your application file correctly.",
      ],
      [
        "Ongoing Readiness",
        "We help you stay compliant with professional tax rules after you're certified.",
      ],
    ],
    offersTitle: "Benefits of Professional Tax Certification",
    offers: [
      [
        "Legal Compliance",
        "Stay aligned with local tax rules and avoid penalties and notices.",
      ],
      [
        "Business Credibility",
        "Build more trust with clients, partners, and institutions.",
      ],
      [
        "Growth Opportunities",
        "Open the door to new business, contracts, and institutional work.",
      ],
    ],
    processTitle: "Certification Process",
    processSubtitle:
      "A simple 4-step process to make certification quick and easy.",
    processSteps: [
      [
        "Initial Assessment",
        "We review your business and figure out the right certification path for you.",
      ],
      [
        "Documentation",
        "We collect and prepare the documents and forms needed for your application.",
      ],
      [
        "Application",
        "We submit your application and follow up with the tax authority.",
      ],
      [
        "Certification",
        "Once approved, we guide you through getting your certificate and what to do next.",
      ],
    ],
    documentGroups: [
      [
        "Business Documents",
        [
          "Business registration certificate",
          "NTN certificate",
          "Bank account details",
        ],
      ],
      [
        "Personal Documents",
        [
          "CNIC copy",
          "Proof of address",
          "Professional credentials",
        ],
      ],
    ],
  },
  {
    id: 12,
    slug: "pra-bra-srb-registration",
    icon: "flaticon-ship",
    navTitle: "PRA, KPRA, BRA, SRB Registration",
    title: "PRA, KPRA, BRA & SRB Registration",
    shortTitle: "PRA, KPRA, BRA & SRB Registration Services",
    pageTitle: "PRA, KPRA, BRA & SRB Registration Services",
    cardText:
      "We help you register with PRA, KPRA, BRA, and SRB, from documents to compliance, so it's one less thing to worry about.",
    intro:
      "We help businesses register with the Port Regulatory Authority, Khyber Pakhtunkhwa Revenue Authority, Bin Qasim Regulatory Authority, and the Sindh Revenue Board. Whether you're a company, logistics provider, port operator, or service provider, we manage the whole process for you.",
    overviewTitle: "Port & Regulatory Support",
    overviewItems: [
      [
        "Initial Assessment & Advisory",
        "We review your business and tell you which authority's requirements apply to you.",
      ],
      [
        "Documentation & Submission",
        "We prepare your documents, submit your application, and follow up until it's approved.",
      ],
      [
        "Compliance & Advisory",
        "After registration, we explain your ongoing tax and compliance obligations in simple terms.",
      ],
    ],
    contentSections: [
      [
        "What We Cover",
        "Registration planning, documentation, compliance checks, and ongoing advice for PRA, KPRA, BRA, and SRB matters.",
      ],
    ],
    offersTitle: "Registration Requirements",
    offers: [
      [
        "Corporate Documents",
        "Certificate of Incorporation, Memorandum and Articles of Association or Partnership Deed, and Board Resolution or Authorization Letter.",
      ],
      [
        "Operational Documents",
        "Port service agreements, logistics and shipping permits, and safety compliance certificates.",
      ],
      [
        "Financial & Tax Documents",
        "NTN registration, KPRA or SRB registration where applicable, bank statements, and audited financial statements if required.",
      ],
    ],
    highlightsTitle: "Why Businesses Use This Service",
    highlights: [
      "One point of contact for multiple regulatory and tax authorities, including KPRA",
      "Better-prepared files that reduce delays",
      "Clear guidance on compliance after registration",
      "Support built for port operators, logistics businesses, and service providers",
    ],
    caseStudiesTitle: "Selected Case Studies",
    caseStudies: [
      [
        "Port Operator Registration",
        "We helped a port operator get PRA registration and operational permits, so they could start operations sooner.",
      ],
      [
        "KPRA Services Registration",
        "We helped a service provider with KPRA registration and filing for sales tax in Khyber Pakhtunkhwa.",
      ],
      [
        "BRA Compliance Rollout",
        "We supported a Bin Qasim operator with documents and compliance, improving their regulatory standing.",
      ],
      [
        "SRB Tax Regularization",
        "We helped a logistics company fix its SRB registration and filings, reducing penalty risk.",
      ],
    ],
    faqTitle: "Frequently Asked Questions",
    faqs: [
      [
        "What is the difference between PRA, KPRA, BRA and SRB?",
        "PRA and BRA are port authorities. KPRA and SRB are provincial tax authorities for services in Khyber Pakhtunkhwa and Sindh. Each has its own rules depending on your business.",
      ],
      [
        "How long does registration take?",
        "It depends on the authority and how complete your file is. Most well-prepared applications take about 4 to 12 weeks.",
      ],
    ],
  },
  {
    id: 13,
    slug: "trademark-registration",
    icon: "flaticon-protection",
    navTitle: "Trademark Registration",
    title: "Trademark Registration",
    shortTitle: "Protect Your Brand with Trademark Registration",
    pageTitle: "Trademark Registration Services",
    cardText:
      "We register your brand name, logo, or slogan with IPO-Pakistan, so no one else can legally use it.",
    intro:
      "Your brand name and logo are part of what makes your business recognizable. Zawix Business Consultants helps you register your trademark with the Intellectual Property Organization of Pakistan (IPO-Pakistan), so your brand is legally protected and other businesses can't copy it.",
    overviewTitle: "What We Handle For Your Trademark Registration",
    overviewItems: [
      [
        "Trademark Search",
        "Before applying, we check that your brand name or logo isn't already registered by someone else.",
      ],
      [
        "Application Filing",
        "We prepare your application and file it with IPO-Pakistan under the correct class of goods or services.",
      ],
      [
        "Follow-Up & Certificate",
        "We track your application, respond to any objections, and follow up until your trademark is registered.",
      ],
    ],
    offersTitle: "Our Trademark Services",
    offers: [
      [
        "Brand & Logo Registration",
        "We register your business name, logo, tagline, or product brand as a trademark.",
      ],
      [
        "Trademark Class Selection",
        "We help you choose the right class of goods or services for your application, so it's filed correctly the first time.",
      ],
      [
        "Objection & Opposition Handling",
        "If someone objects to your application, we help you respond and protect your registration.",
      ],
      [
        "Trademark Renewal",
        "We remind you before your trademark expires and handle the renewal process for you.",
      ],
    ],
    highlightsTitle: "Why Register Your Trademark?",
    highlights: [
      "Stops other businesses from legally using your brand name or logo",
      "Builds trust with customers and makes your brand look more established",
      "Gives you the legal right to take action if someone copies your brand",
      "Adds value to your business as it grows",
    ],
    noteTitle: "Documents You'll Need",
    note:
      "You'll need a clear copy of your logo or brand name, your business registration or CNIC, and details of the goods or services your brand covers. We'll guide you through anything else that's needed.",
    processDuration: "Filing usually done within a few working days",
    processTitle: "Our Trademark Registration Process",
    processSubtitle:
      "A simple process to get your brand legally protected.",
    processSteps: [
      [
        "Initial Consultation",
        "We discuss your brand and check which class of goods or services applies.",
      ],
      [
        "Trademark Search",
        "We search existing records to make sure your brand name or logo is available.",
      ],
      [
        "Application Filing",
        "We prepare and file your application with IPO-Pakistan.",
      ],
      [
        "Examination & Publication",
        "IPO-Pakistan reviews your application and publishes it for objections, if any.",
      ],
      [
        "Registration Certificate",
        "Once approved, you receive your official trademark registration certificate.",
      ],
    ],
    documentGroups: [
      [
        "Brand Documents",
        [
          "Clear image of your logo or wordmark",
          "List of goods or services your brand covers",
        ],
      ],
      [
        "Owner Documents",
        [
          "CNIC copy of the owner",
          "Business registration certificate, if applicable",
        ],
      ],
    ],
    faqTitle: "Frequently Asked Questions",
    faqs: [
      [
        "How long does trademark registration take?",
        "Filing is quick, but full registration with IPO-Pakistan can take several months, depending on objections and processing time.",
      ],
      [
        "Do I need a registered company to apply?",
        "No. Both individuals and registered businesses can apply for a trademark.",
      ],
    ],
  },
];

export const CONTACT_PAGE = {
  intro:
    "Have a question or need help getting started? Send us a message, or call or WhatsApp us. We usually reply within one business day.",
  prompt:
    "Want advice for your specific business? Get in touch and we'll guide you, free of charge.",
  consultation:
    "Book a Free Consultation - Call or WhatsApp us today, and one of our experts will explain which services are right for your business.",
};

export const PRIVACY_POLICY = {
  effectiveDate: "January 1, 2024",
  lastUpdated: "December 2024",
  introduction:
    'Zawix Business Consultants ("we", "us", or "our") is committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website at zawix.com or engage our services. Please read this policy carefully. If you disagree with its terms, please discontinue use of our site.',
};

export const PRIVACY_SECTIONS = [
  ["1. Information We Collect", "We collect personal information that you voluntarily provide to us when you fill out a contact or inquiry form on our website, request a consultation or appointment, send us an email or WhatsApp message, or engage our services directly.", "Types of information collected may include Full Name, Email Address, Phone Number, Business Name and Type, details of services you inquire about, and any other information you choose to share with us. We do not collect sensitive financial information such as bank account numbers, payment card details, or passwords through our website."],
  ["2. How We Use Your Information", "We use the personal information we collect to respond to your inquiries and provide the services you request, schedule consultations and meetings, send relevant service information, updates, or promotional content only if you opt in, improve our website and service offerings, comply with our legal obligations, and protect our business interests and prevent fraud."],
  ["3. Sharing Of Information", "Zawix Business Consultants does not sell, trade, rent, or share your personal information with third parties for marketing purposes.", "We may share your information only in limited circumstances, including with government authorities such as FBR, SECP, PEC, and AEDB as required to provide our services on your behalf, with legal or professional advisors as required by law, to comply with a court order, legal process, or government request, or to protect the rights, property, or safety of Zawix, our clients, or others."],
  ["4. Data Retention", "We retain your personal information only for as long as necessary to fulfill the purposes outlined in this policy and to comply with our legal obligations. Client records related to regulatory filings may be retained for up to 7 years as required by Pakistani law."],
  ["5. Cookies", "Our website may use basic cookies to enhance user experience, analyze website traffic, and improve functionality. You may disable cookies through your browser settings; however, this may affect certain features of the website."],
  ["6. Third-Party Links", "Our website may contain links to third-party websites such as government portals. We are not responsible for the privacy practices of these external sites and encourage you to review their individual privacy policies."],
  ["7. Security", "We implement reasonable technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of internet transmission is 100% secure, and we cannot guarantee absolute security."],
  ["8. Your Rights", "You have the right to request access to the personal information we hold about you, request correction of any inaccurate information, request deletion of your personal information subject to legal retention requirements, and withdraw consent for marketing communications at any time. To exercise any of these rights, please contact us at info@zawix.com."],
  ["9. Children's Privacy", "Our services are intended for adults conducting business activities. We do not knowingly collect personal information from individuals under the age of 18."],
  ["10. Changes To This Policy", "We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with an updated Last Updated date. Continued use of our website after changes constitutes your acceptance of the revised policy."],
  ["11. Contact Us", "If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us using the details below."],
];

export const SERVICE_FAQ = [
  ["Which service should I start with?", "If your business isn't registered yet, start with SECP company registration. If you're already running a business, you may need FBR tax registration, PEC licensing, or other approvals, depending on your industry."],
  ["Do you help with documentation as well?", "Yes. We prepare your documents, submit your application, and follow up with the government office until the work is done. You don't need to handle any of it yourself."],
  ["Can I contact you before deciding on a service?", "Yes. Call, email, or WhatsApp us anytime, and we'll guide you for free before you decide which service you need."],
];

export const BLOG_POSTS = [
  {
    id: 1,
    slug: "secp-company-registration-guide-pakistan",
    relatedService: "secp-services",
    category: "Company Registration",
    tags: ["SECP", "Company Registration", "Private Limited"],
    title: "SECP Company Registration in Pakistan: A Simple Step-by-Step Guide",
    metaTitle: "SECP Company Registration in Pakistan | Step-by-Step Guide",
    metaDescription:
      "Learn how to register a Private Limited or Single Member Company with SECP in Pakistan. Simple steps, required documents, timelines, and how Zawix can help.",
    keywords: [
      "SECP company registration",
      "how to register a company in Pakistan",
      "Private Limited Company registration",
      "SECP registration process",
      "company registration Islamabad",
    ],
    excerpt:
      "Thinking about registering your company with SECP? Here's a simple, plain-language guide to the whole process, from choosing a name to getting your certificate.",
    image: "secp.jpeg",
    imageAlt: "SECP company registration documents and certificate",
    publishDate: "2026-07-10",
    readTime: "6 min read",
    content: [
      { type: "p", text: "If you're starting a business in Pakistan, registering it with the Securities and Exchange Commission of Pakistan (SECP) is usually one of the first steps. It makes your business a legal entity, separate from you personally, and it opens the door to opening a business bank account, signing contracts, and bidding on bigger projects." },
      { type: "h2", text: "Which Company Type Should You Register?" },
      { type: "p", text: "Most small and medium businesses in Pakistan choose one of these options:" },
      { type: "ul", items: [
        "Single Member Company (SMC) - one owner, limited liability",
        "Private Limited Company - two or more shareholders, the most common choice",
        "Limited Liability Partnership (LLP) - a mix of a partnership and a company",
      ]},
      { type: "h2", text: "Steps to Register Your Company" },
      { type: "ul", items: [
        "Check name availability and reserve your company name with SECP",
        "Prepare your Memorandum and Articles of Association",
        "Submit your incorporation documents through SECP's online portal",
        "Pay the registration fee",
        "Receive your Certificate of Incorporation",
      ]},
      { type: "p", text: "Most straightforward registrations are completed within 15 to 20 working days, as long as the documents are accurate and complete the first time." },
      { type: "h2", text: "Documents You'll Need" },
      { type: "p", text: "You'll typically need CNIC copies of all directors and shareholders, your proposed company name, a registered office address, and details of your business activity. If any shareholder is a company, additional documents apply." },
      { type: "h2", text: "What to Do After Incorporation" },
      { type: "ul", items: [
        "Open a business bank account in the company's name",
        "Register for an NTN and any applicable sales tax",
        "Set up company books and keep invoices and receipts organized",
        "Track annual returns and other SECP filing deadlines",
      ]},
      { type: "h2", text: "Common Reasons for Delay" },
      { type: "p", text: "Name similarity, unclear business activities, mismatched CNIC details, and incomplete director information are common reasons an application is returned. Check every detail before submission and keep the spelling consistent across all documents." },
      { type: "h2", text: "Why Work With a Consultant?" },
      { type: "p", text: "SECP's online system can be confusing if you haven't used it before, and small mistakes in your documents can lead to delays or rejection. At Zawix, we prepare and check everything before it's submitted, so your registration moves smoothly the first time." },
    ],
    faqs: [
      ["How long does SECP registration take?", "Most standard registrations are completed in 15 to 20 working days once all documents are in order."],
      ["Can a foreigner register a company in Pakistan?", "Yes, foreign nationals and foreign companies can register a company in Pakistan, though additional documentation is required."],
    ],
  },
  {
    id: 2,
    slug: "boi-registration-benefits-pakistan",
    relatedService: "boi-registration",
    category: "Investment",
    tags: ["BOI", "Investment", "Business Setup"],
    title: "What Is BOI Registration and Does Your Business Need It?",
    metaTitle: "BOI Registration in Pakistan | Benefits & Eligibility Guide",
    metaDescription:
      "Understand what Board of Investment (BOI) registration is, who needs it, and the benefits it offers to businesses and investors in Pakistan.",
    keywords: [
      "BOI registration Pakistan",
      "Board of Investment Pakistan",
      "investment registration Pakistan",
      "foreign investment Pakistan",
    ],
    excerpt:
      "BOI registration can open the door to tax incentives and faster approvals, but it isn't required for every business. Here's how to know if it applies to you.",
    image: "boi.jpeg",
    imageAlt: "Board of Investment registration consultation",
    publishDate: "2026-07-14",
    readTime: "5 min read",
    content: [
      { type: "p", text: "The Board of Investment (BOI) is Pakistan's main government body for attracting and supporting local and foreign investment. If your business is planning a larger project, especially in manufacturing, infrastructure, or a similar sector, BOI registration is worth considering." },
      { type: "h2", text: "Who Should Consider BOI Registration?" },
      { type: "ul", items: [
        "Manufacturing and industrial businesses",
        "Infrastructure and construction projects",
        "IT and technology companies",
        "Renewable energy projects",
        "Export-focused businesses",
      ]},
      { type: "h2", text: "What Are the Benefits?" },
      { type: "p", text: "Depending on your project, BOI registration can give you access to tax breaks, reduced import duties on equipment, faster coordination with government departments, and stronger credibility with banks and international partners." },
      { type: "h2", text: "How the Process Works" },
      { type: "p", text: "It starts with an eligibility check and a project proposal, followed by document submission and follow-up with BOI until approval. Having a well-prepared proposal makes a big difference in how quickly it moves." },
      { type: "h2", text: "Information Your Proposal Should Explain" },
      { type: "ul", items: [
        "What your business will produce or provide",
        "The total investment and where the funds will come from",
        "The location, equipment, and expected project timeline",
        "The number of jobs and other benefits the project may create",
      ]},
      { type: "h2", text: "Important Things to Check First" },
      { type: "p", text: "BOI support or registration does not replace company, tax, environmental, licensing, or provincial approvals. Check the rules for your sector early so you do not build an investment plan around an incentive that does not apply to your project." },
      { type: "p", text: "Zawix helps you figure out if BOI registration fits your project, prepares your investment proposal, and manages the whole submission process on your behalf." },
    ],
    faqs: [
      ["Is BOI registration mandatory for every business?", "No, it's mainly relevant for larger projects in specific sectors like manufacturing, infrastructure, and energy."],
      ["Does BOI registration guarantee tax exemptions?", "Not automatically. Incentives depend on your project type and the applicable government policy at the time of registration."],
    ],
  },
  {
    id: 3,
    slug: "pec-registration-guide-engineers-contractors",
    relatedService: "pec-services",
    category: "Engineering & Construction",
    tags: ["PEC", "Engineering", "Construction"],
    title: "PEC Registration Explained: What Engineers and Contractors Need to Know",
    metaTitle: "PEC Registration Guide | Pakistan Engineering Council",
    metaDescription:
      "A clear guide to PEC registration for engineers, construction firms, and consulting companies in Pakistan, including categories, renewal, and upgrades.",
    keywords: [
      "PEC registration",
      "Pakistan Engineering Council registration",
      "PEC license renewal",
      "PEC category upgrade",
      "engineering firm registration Pakistan",
    ],
    excerpt:
      "If you work in construction or engineering in Pakistan, PEC registration isn't optional. Here's what it covers and how to get it done without delays.",
    image: "pec.jpeg",
    imageAlt: "PEC registration certificate for engineering firm",
    publishDate: "2026-07-18",
    readTime: "6 min read",
    content: [
      { type: "p", text: "The Pakistan Engineering Council (PEC) regulates engineering practice across the country. If you're an engineer, a construction company, or a consulting firm, PEC registration is usually required before you can legally bid on and carry out engineering work." },
      { type: "h2", text: "Types of PEC Registration" },
      { type: "ul", items: [
        "New firm registration for construction and engineering companies",
        "Consultant firm registration for engineering consultancies",
        "Foreign company registration for international firms working in Pakistan",
        "Category upgrades, from smaller categories up to CA or OA",
        "Specialization codes for specific engineering fields",
      ]},
      { type: "h2", text: "Why Renewal Matters" },
      { type: "p", text: "PEC registration isn't a one-time thing. Licenses need to be renewed on time, or your firm risks losing its ability to bid on projects. Missing a renewal deadline can also make future renewals more complicated." },
      { type: "h2", text: "Common Mistakes to Avoid" },
      { type: "p", text: "The most common delays happen because of incomplete experience documentation, missing specialization codes, or applying under the wrong category. Getting this right the first time saves weeks of back and forth." },
      { type: "h2", text: "A Simple PEC Preparation Checklist" },
      { type: "ul", items: [
        "Confirm that the firm's directors and engineers meet the category rules",
        "Collect engineer registration details and updated firm information",
        "Organize contracts, completion certificates, and financial records",
        "Choose the correct specialization codes before submitting the application",
      ]},
      { type: "h2", text: "Renewal and Category Upgrade Tips" },
      { type: "p", text: "Keep a copy of your current license, note its expiry date, and update your experience record after every completed project. Starting early gives you time to correct missing documents or apply for a more suitable category." },
      { type: "p", text: "Zawix has helped many construction and engineering firms across Pakistan with new registration, renewals, and category upgrades, handling the paperwork so you can focus on your projects." },
    ],
    faqs: [
      ["What happens if my PEC registration expires?", "You may lose eligibility to bid on new projects until it's renewed, so it's best to start the renewal process well before the expiry date."],
      ["Can a foreign engineering company register with PEC?", "Yes, foreign firms can register under the appropriate PEC category to legally operate in Pakistan."],
    ],
  },
  {
    id: 4,
    slug: "government-enlistments-construction-companies-pakistan",
    relatedService: "additional-services",
    category: "Compliance",
    tags: ["C&W", "PWD", "CDA", "Government Contracts"],
    title: "Government Department Enlistments Every Construction Company Should Know About",
    metaTitle: "C&W, PWD & CDA Enlistment Guide for Construction Companies",
    metaDescription:
      "Learn which government department enlistments your construction company needs to bid on public sector projects in Pakistan, including C&W, PWD, and CDA.",
    keywords: [
      "C&W enlistment Pakistan",
      "PWD enlistment",
      "CDA enlistment Islamabad",
      "government contractor registration Pakistan",
    ],
    excerpt:
      "Missing the right government enlistment can mean missing out on major contracts. Here's a quick overview of what construction companies typically need.",
    image: "goverment.jpeg",
    imageAlt: "Government department enlistment documents for contractors",
    publishDate: "2026-07-22",
    readTime: "5 min read",
    content: [
      { type: "p", text: "Many businesses lose out on government contracts simply because they aren't enlisted with the right department. If you want to bid on public sector construction or supply projects in Pakistan, here are the main enlistments to know about." },
      { type: "h2", text: "Key Enlistments for Contractors" },
      { type: "ul", items: [
        "C&W (Communication & Works) Department - required for many provincial government projects",
        "PWD (Public Works Department) - needed to access federal and provincial construction tenders",
        "CDA (Capital Development Authority) - required for construction work within Islamabad",
        "PPRA registration - required for bidding on federal government contracts",
      ]},
      { type: "h2", text: "Why This Matters" },
      { type: "p", text: "Without these enlistments, you simply can't submit a bid for many government tenders, no matter how strong your proposal is. Getting enlisted early means you're ready to compete as soon as the right opportunity comes up." },
      { type: "h2", text: "Keeping Your Enlistment Active" },
      { type: "p", text: "These enlistments usually need to be renewed periodically, and your documents need to stay up to date. Missing a renewal can quietly disqualify you from tenders you'd otherwise be eligible for." },
      { type: "h2", text: "Documents Contractors Commonly Prepare" },
      { type: "ul", items: [
        "Company incorporation and NTN documents",
        "Valid PEC license and details of technical staff",
        "Financial statements, bank information, and tax records",
        "Past project experience, completion certificates, and equipment details",
      ]},
      { type: "h2", text: "Before You Apply" },
      { type: "p", text: "Check the tendering body's current category, fee, and renewal requirements because they can differ by department and location. Keep scanned documents clear, current, and named consistently so the file is easy to review." },
      { type: "p", text: "Zawix handles enlistment applications and renewals for C&W, PWD, CDA, and PPRA, so your company stays ready for government contract opportunities." },
    ],
    faqs: [
      ["Do I need all these enlistments, or just one?", "It depends on which government bodies you plan to bid with. Many contractors register with more than one to access a wider range of tenders."],
      ["How often do these enlistments need renewal?", "Renewal periods vary by department, but most require periodic renewal, so it's worth tracking your expiry dates."],
    ],
  },
  {
    id: 5,
    slug: "aedb-ppib-solar-registration-guide",
    relatedService: "aedb-services",
    category: "Renewable Energy",
    tags: ["Solar", "AEDB", "PPIB", "Net Metering"],
    title: "AEDB / PPIB Registration for Solar Companies: What You Need to Know",
    metaTitle: "AEDB PPIB Solar Registration Guide | Categories & Requirements",
    metaDescription:
      "A practical guide to AEDB/PPIB registration for solar vendors and installers in Pakistan, covering categories, requirements, and net metering.",
    keywords: [
      "AEDB registration",
      "PPIB solar registration",
      "solar vendor registration Pakistan",
      "net metering registration",
      "solar company license Pakistan",
    ],
    excerpt:
      "Solar is booming in Pakistan, and AEDB / PPIB registration is what separates a recognized vendor from an unregistered one. Here's how it works.",
    image: "aedb.jpeg",
    imageAlt: "Solar panel installation and AEDB registration",
    publishDate: "2026-07-27",
    readTime: "6 min read",
    content: [
      { type: "p", text: "Pakistan's solar market has grown quickly over the past few years, and with it, the importance of proper vendor registration. AEDB registration, now handled under PPIB, is what allows solar companies to do net-metering installations and bid on larger projects." },
      { type: "h2", text: "Registration Categories" },
      { type: "ul", items: [
        "C-3 category - for smaller residential and commercial projects, up to 250 kW",
        "C-2 category - for growing companies, up to 500 kW",
        "C-1 category - for larger companies with no capacity limit",
      ]},
      { type: "h2", text: "What You'll Need" },
      { type: "p", text: "A valid PEC registration is usually required alongside your AEDB/PPIB application, along with a company profile, qualified technical staff, and financial documents. Some categories also require a bank guarantee." },
      { type: "h2", text: "Why Registration Matters" },
      { type: "p", text: "Being a registered vendor builds trust with customers and banks, and it's often a requirement for net-metering approvals and larger institutional projects. Unregistered vendors can find themselves shut out of bigger opportunities." },
      { type: "h2", text: "How to Choose the Right Category" },
      { type: "p", text: "Choose a category based on the size of projects you can genuinely complete, your technical team, available equipment, and the financial requirements. Applying for a category that is too high can create avoidable document and guarantee problems." },
      { type: "h2", text: "What to Keep Ready" },
      { type: "ul", items: [
        "Company, tax, and PEC registration documents",
        "Details of qualified engineers and technical staff",
        "Company profile and completed project evidence",
        "Financial records and any required bank guarantee",
      ]},
      { type: "p", text: "Zawix helps solar companies choose the right category, prepare their documents, and manage the full registration process from start to finish." },
    ],
    faqs: [
      ["Do I need PEC registration before applying to AEDB/PPIB?", "Yes, a valid PEC registration in the relevant category is generally a requirement for AEDB/PPIB registration."],
      ["How long does AEDB/PPIB registration take?", "With a complete file, most applications take around 4 to 6 weeks to process."],
    ],
  },
  {
    id: 6,
    slug: "fbr-tax-registration-ntn-sales-tax-guide",
    relatedService: "fbr-services",
    category: "Taxation",
    tags: ["FBR", "NTN", "Sales Tax"],
    title: "FBR Tax Registration Made Simple: NTN and Sales Tax Explained",
    metaTitle: "FBR Tax Registration Guide | NTN & Sales Tax in Pakistan",
    metaDescription:
      "Understand NTN registration, sales tax registration, and ongoing FBR compliance for individuals and businesses in Pakistan, explained in plain language.",
    keywords: [
      "FBR registration",
      "NTN registration Pakistan",
      "sales tax registration Pakistan",
      "how to become a filer in Pakistan",
    ],
    excerpt:
      "Taxes don't have to be confusing. Here's a simple breakdown of NTN registration, sales tax, and what it means to become an active taxpayer in Pakistan.",
    image: "tax_Registration.jpeg",
    imageAlt: "FBR NTN and sales tax registration documents",
    publishDate: "2026-08-01",
    readTime: "5 min read",
    content: [
      { type: "p", text: "Whether you're an individual, a freelancer, or a business owner, registering with the Federal Board of Revenue (FBR) is an important step for staying compliant and avoiding penalties." },
      { type: "h2", text: "What Is an NTN?" },
      { type: "p", text: "Your National Tax Number (NTN) is your basic tax identity in Pakistan. Individuals, sole proprietors, partnerships, and companies all need one to file taxes and, in many cases, to open a business bank account." },
      { type: "h2", text: "Do You Need Sales Tax Registration?" },
      { type: "p", text: "If your business sells taxable goods or services above certain thresholds, or if a client requires it, you'll likely need sales tax registration as well, whether federal (GST) or provincial (PRA, KPRA, SRB, BRA depending on your location)." },
      { type: "h2", text: "Becoming an Active Taxpayer" },
      { type: "p", text: "Filing your annual tax return keeps you on FBR's Active Taxpayer List (ATL), which comes with lower withholding tax rates on many transactions and is often required for government and corporate dealings." },
      { type: "h2", text: "A Simple Registration Checklist" },
      { type: "ul", items: [
        "CNIC, mobile number, and email address",
        "Business or employer details and address proof",
        "Bank account and income information",
        "Sales and purchase records if sales tax registration applies",
      ]},
      { type: "h2", text: "Registration Is Only the First Step" },
      { type: "p", text: "After getting an NTN or sales tax number, you still need to keep records, file the required returns, and respond to notices. The exact requirements depend on whether you are salaried, self-employed, a company, or providing services in a province." },
      { type: "p", text: "Zawix helps individuals and businesses register their NTN, complete sales tax registration, and file returns on time, so you can stay compliant without the stress." },
    ],
    faqs: [
      ["What's the difference between a filer and a non-filer?", "A filer is someone on FBR's Active Taxpayer List after filing their return. Filers usually pay lower withholding tax on banking, property, and vehicle transactions."],
      ["Do freelancers need to register with FBR?", "Yes, freelancers earning taxable income are generally required to register for an NTN and file annual returns."],
    ],
  },
  {
    id: 7,
    slug: "why-your-business-needs-a-professional-audit-report",
    relatedService: "audit-report",
    category: "Audit & Finance",
    tags: ["Audit", "Financial Statements", "Compliance"],
    title: "Why Your Business Needs a Professional Audit Report",
    metaTitle: "Business Audit Reports in Pakistan | Why They Matter",
    metaDescription:
      "Find out when your business needs an audit report, what it includes, and how a professional audit can strengthen your financial credibility.",
    keywords: [
      "audit report Pakistan",
      "statutory audit",
      "financial statements Pakistan",
      "business audit services",
    ],
    excerpt:
      "An audit report isn't just a legal formality. It can strengthen your credibility with banks, partners, and regulators. Here's when you might need one.",
    image: "audit.jpeg",
    imageAlt: "Auditor reviewing financial statements",
    publishDate: "2026-08-05",
    readTime: "5 min read",
    content: [
      { type: "p", text: "An audit report is an independent check of your company's financial statements. For some businesses it's a legal requirement, and for others, it's a smart move that builds trust with banks, investors, and clients." },
      { type: "h2", text: "Types of Audits" },
      { type: "ul", items: [
        "Statutory audit - required by law for certain company types",
        "Internal audit - reviews internal controls and processes",
        "Compliance audit - checks adherence to specific regulations or contracts",
        "Special purpose audit - for a specific requirement, such as a loan application or tender",
      ]},
      { type: "h2", text: "What's Included in an Audit Report" },
      { type: "p", text: "A good audit report doesn't just list numbers. It includes a clear opinion on your financial statements, along with a management letter that points out any weaknesses in your processes and how to fix them." },
      { type: "h2", text: "When Do You Need One?" },
      { type: "p", text: "Common triggers include annual SECP compliance requirements, bank loan applications, government tender requirements, and simply wanting a clearer picture of your company's financial health." },
      { type: "h2", text: "How to Prepare for an Audit" },
      { type: "ul", items: [
        "Keep invoices, receipts, payroll records, and bank statements together",
        "Reconcile the bank and cash balances with your books",
        "List company assets, loans, outstanding bills, and customer balances",
        "Share contracts and tax filings that affect the financial statements",
      ]},
      { type: "h2", text: "What a Good Audit Gives You" },
      { type: "p", text: "A professional audit gives owners a clearer view of profit, cash flow, debts, and weak controls. It can also help identify errors early, improve reporting, and make conversations with banks or investors easier." },
      { type: "p", text: "Zawix prepares audit reports and financial statements tailored to your specific needs, with clear findings and practical recommendations." },
    ],
    faqs: [
      ["Is an audit required for every company in Pakistan?", "It depends on your company type and size. Many private limited companies are required to have an annual statutory audit."],
      ["How long does an audit take?", "It depends on the size and complexity of your business, but most small to mid-sized company audits take a few weeks once records are organized."],
    ],
  },
  {
    id: 8,
    slug: "chamber-of-commerce-membership-benefits-pakistan",
    relatedService: "chamber-of-commerce",
    category: "Business Growth",
    tags: ["Chamber of Commerce", "Trade", "Networking"],
    title: "Is Chamber of Commerce Membership Worth It for Your Business?",
    metaTitle: "Chamber of Commerce Membership Benefits | Is It Worth It?",
    metaDescription:
      "Explore the benefits of Chamber of Commerce membership in Pakistan, from networking and credibility to trade documentation support.",
    keywords: [
      "Chamber of Commerce membership Pakistan",
      "trade documentation Pakistan",
      "business networking Pakistan",
    ],
    excerpt:
      "Chamber of Commerce membership can open doors you didn't know existed. Here's what it actually offers beyond just a certificate on the wall.",
    image: "chamber.jpeg",
    imageAlt: "Chamber of Commerce membership certificate and networking",
    publishDate: "2026-08-09",
    readTime: "4 min read",
    content: [
      { type: "p", text: "Chamber of Commerce membership is often overlooked by small and medium businesses, but it can offer real, practical value beyond just credibility." },
      { type: "h2", text: "What You Get With Membership" },
      { type: "ul", items: [
        "Access to networking events and trade delegations",
        "Help with certificates of origin and trade documents",
        "Updates on policy changes that affect your industry",
        "A stronger, more established business profile",
      ]},
      { type: "h2", text: "Who Benefits Most?" },
      { type: "p", text: "Businesses involved in import/export, manufacturing, and larger B2B dealings tend to see the most value, since chambers often provide documentation support and connections that are hard to access otherwise." },
      { type: "h2", text: "What You May Need to Apply" },
      { type: "ul", items: [
        "Company or business registration documents",
        "NTN, sales tax, and bank details where applicable",
        "CNIC or identification documents of owners and authorized representatives",
        "Business address proof and recent photographs or forms requested by the chamber",
      ]},
      { type: "h2", text: "How to Get Real Value from Membership" },
      { type: "p", text: "Membership is most useful when you actively use it. Attend relevant events, ask about trade documentation, follow policy updates, and keep your membership renewal and business information current." },
      { type: "p", text: "Zawix helps businesses apply for Chamber of Commerce membership in their city or region, preparing the required documents so the application moves quickly." },
    ],
    faqs: [
      ["Is Chamber membership required by law?", "No, it's not legally required for most businesses, but it can be practically necessary for certain trade activities, like getting a certificate of origin."],
      ["How long does membership approval take?", "It varies by chamber, but a well-prepared application typically moves faster than an incomplete one."],
    ],
  },
  {
    id: 9,
    slug: "import-export-license-registration-pakistan",
    relatedService: "import-export-registration",
    category: "Trade",
    tags: ["Import Export", "Customs", "Trade License"],
    title: "How to Get an Import Export License in Pakistan",
    metaTitle: "Import Export License Registration Guide | Pakistan",
    metaDescription:
      "A clear guide to getting your import export registration, customs documentation, and chamber membership sorted for trading legally in Pakistan.",
    keywords: [
      "import export license Pakistan",
      "IE code Pakistan",
      "customs registration Pakistan",
      "how to start import export business",
    ],
    excerpt:
      "Want to start importing or exporting? Here's what you actually need to get set up, from your IE code to your customs paperwork.",
    image: "import_export.jpeg",
    imageAlt: "Import export shipping and customs documentation",
    publishDate: "2026-08-13",
    readTime: "5 min read",
    content: [
      { type: "p", text: "Starting an import or export business in Pakistan involves more than just finding a supplier or buyer. You'll need the right registrations and documentation to trade legally and avoid delays at customs." },
      { type: "h2", text: "What You'll Need to Get Started" },
      { type: "ul", items: [
        "NTN and sales tax registration with FBR",
        "Customs registration and tariff classification",
        "An import export code where applicable",
        "Chamber of Commerce membership, often required for certificates of origin",
      ]},
      { type: "h2", text: "Shipping Documentation" },
      { type: "p", text: "Beyond registration, you'll need to understand documents like the bill of lading, certificate of origin, and other customs clearance paperwork. Missing or incorrect documents are one of the most common causes of shipment delays." },
      { type: "h2", text: "Before Your First Shipment" },
      { type: "ul", items: [
        "Confirm the product's tariff code, duties, and import restrictions",
        "Agree clear payment and delivery terms with the supplier or buyer",
        "Check the invoice, packing list, certificate of origin, and transport document",
        "Use a reliable customs clearing agent when the shipment is complex",
      ]},
      { type: "h2", text: "Common Problems to Avoid" },
      { type: "p", text: "Incorrect product descriptions, wrong tariff codes, missing certificates, and mismatched quantities can lead to inspections, extra costs, or delays. Review the complete file before the goods leave the supplier." },
      { type: "p", text: "Zawix helps businesses complete their import export registration, prepare trade documents, and understand exactly what's needed at each step, so shipments move without unnecessary hold-ups." },
    ],
    faqs: [
      ["Do I need a registered company to import or export?", "You can operate as a sole proprietor in many cases, but you'll still need proper NTN, sales tax, and customs registration."],
      ["What causes most shipment delays?", "Incomplete or incorrect documentation is the most common cause, which is why getting your paperwork right from the start matters."],
    ],
  },
  {
    id: 10,
    slug: "income-tax-return-filing-guide-pakistan",
    relatedService: "income-tax-return",
    category: "Taxation",
    tags: ["Income Tax", "Tax Filing", "FBR"],
    title: "Income Tax Return Filing in Pakistan: What You Need to Know",
    metaTitle: "Income Tax Return Filing Guide | Pakistan",
    metaDescription:
      "A simple guide to filing your income tax return in Pakistan, whether you're salaried, self-employed, running a company, or a non-profit.",
    keywords: [
      "income tax return Pakistan",
      "how to file tax return Pakistan",
      "tax filing Islamabad Rawalpindi",
      "FBR active taxpayer list",
    ],
    excerpt:
      "Filing your income tax return doesn't have to be stressful. Here's what the process looks like and what documents you'll need to have ready.",
    image: "income_tax_return.jpeg",
    imageAlt: "Income tax return filing documents",
    publishDate: "2026-08-17",
    readTime: "5 min read",
    content: [
      { type: "p", text: "Every year, individuals and businesses across Pakistan need to file their income tax return with FBR. It might sound complicated, but with the right documents and guidance, it's a fairly straightforward process." },
      { type: "h2", text: "Who Needs to File?" },
      { type: "ul", items: [
        "Salaried individuals above the taxable income threshold",
        "Sole proprietors and retailers",
        "Partnerships and AOPs",
        "Private and public companies",
        "Non-profit organizations and charitable trusts",
      ]},
      { type: "h2", text: "What You'll Need" },
      { type: "p", text: "This varies depending on your category, but generally includes your NTN, salary certificate or business income details, bank statements, and details of any assets or investments." },
      { type: "h2", text: "Why Filing on Time Matters" },
      { type: "p", text: "Filing on time keeps you on the Active Taxpayer List, which comes with lower withholding tax rates on many everyday transactions, from banking to property purchases." },
      { type: "h2", text: "Documents to Collect Before Filing" },
      { type: "ul", items: [
        "Salary certificate, invoices, or a summary of business income",
        "Bank profit certificates and other income records",
        "Business expenses, withholding tax certificates, and advance tax details",
        "Information about property, vehicles, investments, and other assets",
      ]},
      { type: "h2", text: "What Happens After Submission" },
      { type: "p", text: "Save the submitted return and payment receipts. Check your Active Taxpayer List status after processing, and keep your records in case FBR asks for clarification or supporting documents later." },
      { type: "p", text: "Zawix has helped many clients in Rawalpindi and Islamabad file their returns accurately and on time. We review your documents, prepare your return, and confirm everything is filed correctly." },
    ],
    faqs: [
      ["What happens if I miss the tax filing deadline?", "Late filing can mean losing your position on the Active Taxpayer List and possible penalties, so it's best to file on time or request an extension if needed."],
      ["Can Zawix help even if I've never filed a tax return before?", "Yes, we regularly help first-time filers get registered and file their very first return correctly."],
    ],
  },
  {
    id: 11,
    slug: "professional-tax-certificate-guide-pakistan",
    relatedService: "professional-tax-certificate",
    category: "Taxation",
    tags: ["Professional Tax", "Compliance"],
    title: "Professional Tax Certificate: Who Needs One and Why",
    metaTitle: "Professional Tax Certificate Guide | Pakistan",
    metaDescription:
      "Learn what a professional tax certificate is, who needs one in Pakistan, and how it helps your business stay compliant and credible.",
    keywords: [
      "professional tax certificate Pakistan",
      "professional tax registration",
      "business tax compliance Pakistan",
    ],
    excerpt:
      "Professional tax certification is a smaller compliance step that's easy to overlook, but it matters more than most business owners realize.",
    image: "tax_certification.jpeg",
    imageAlt: "Professional tax certificate and compliance documents",
    publishDate: "2026-08-21",
    readTime: "4 min read",
    content: [
      { type: "p", text: "Professional tax is a provincial tax that applies to certain businesses and professionals in Pakistan. While it's a smaller compliance requirement compared to income tax or sales tax, missing it can still lead to penalties and notices." },
      { type: "h2", text: "Who Typically Needs It?" },
      { type: "p", text: "This generally applies to registered businesses, professionals, and certain trades operating within a province, depending on local rules." },
      { type: "h2", text: "Benefits of Being Certified" },
      { type: "ul", items: [
        "Stay compliant with local tax authorities and avoid penalties",
        "Build credibility with clients, partners, and institutions",
        "Access certain business opportunities and contracts that require proof of tax compliance",
      ]},
      { type: "h2", text: "How to Stay Compliant" },
      { type: "p", text: "Keep your certificate, payment evidence, business address, employee information, and registration details updated. Mark the renewal or payment date on a calendar because provincial requirements and deadlines can differ." },
      { type: "h2", text: "Do Not Confuse It with Other Taxes" },
      { type: "p", text: "Professional tax is separate from income tax and sales tax. You may need to handle more than one of these obligations, so identify the authority responsible for your province and profession before making a payment." },
      { type: "p", text: "Zawix helps businesses and professionals understand their professional tax obligations, prepares the required documents, and manages the certification process so it's one less thing to worry about." },
    ],
    faqs: [
      ["Is professional tax the same as income tax?", "No, they're separate. Professional tax is a smaller, usually provincial tax that applies alongside your regular income tax obligations."],
      ["What happens if I don't get certified?", "You may face penalties or notices from the local tax authority, and it can affect your business's compliance standing."],
    ],
  },
  {
    id: 12,
    slug: "pra-kpra-bra-srb-registration-explained",
    relatedService: "pra-bra-srb-registration",
    category: "Taxation",
    tags: ["PRA", "KPRA", "BRA", "SRB"],
    title: "PRA, KPRA, BRA and SRB Registration: What's the Difference?",
    metaTitle: "PRA vs KPRA vs BRA vs SRB Registration | Pakistan Guide",
    metaDescription:
      "Confused about PRA, KPRA, BRA, and SRB registration? Here's a simple breakdown of what each authority covers and who needs to register.",
    keywords: [
      "PRA registration",
      "KPRA registration",
      "BRA registration",
      "SRB registration",
      "provincial tax authority Pakistan",
    ],
    excerpt:
      "These four acronyms confuse a lot of business owners. Here's a simple explanation of what each one covers and who actually needs to register.",
    image: "pra.jpeg",
    imageAlt: "Port and provincial revenue authority registration documents",
    publishDate: "2026-08-25",
    readTime: "5 min read",
    content: [
      { type: "p", text: "If you operate a port-related business, a logistics company, or a services business in certain provinces, you may come across PRA, KPRA, BRA, or SRB registration requirements. Here's how they differ." },
      { type: "h2", text: "What Each Authority Covers" },
      { type: "ul", items: [
        "PRA (Punjab Revenue Authority) - collects provincial sales tax on services in Punjab",
        "BRA (Balochistan Revenue Authority) - administers provincial sales tax on services in Balochistan",
        "KPRA (Khyber Pakhtunkhwa Revenue Authority) - provincial sales tax on services in KP",
        "SRB (Sindh Revenue Board) - provincial sales tax on services in Sindh",
      ]},
      { type: "h2", text: "Who Needs to Register?" },
      { type: "p", text: "Port operators, logistics providers, and service contractors working in these regions typically need to register with the relevant authority, and in some cases, more than one applies at the same time." },
      { type: "h2", text: "How to Know Which Authority Applies" },
      { type: "ul", items: [
        "Start with the province where the taxable service is provided",
        "Identify whether your activity is a taxable service or sale of goods",
        "Check whether you have customers or branches in another province",
        "Confirm the current registration threshold and filing rules",
      ]},
      { type: "h2", text: "Ongoing Work After Registration" },
      { type: "p", text: "Registration is not the end of the process. You may need to issue compliant invoices, collect and deposit tax, submit monthly returns, and keep records that support your sales and expenses." },
      { type: "p", text: "Zawix helps businesses figure out which of these authorities apply to them, prepares the required documents, and manages the registration and ongoing compliance process." },
    ],
    faqs: [
      ["Do I need to register with more than one of these authorities?", "It's possible, depending on where you operate and what services you provide. We can help you figure out exactly which apply to you."],
      ["How long does registration typically take?", "With a complete file, most applications take around 4 to 12 weeks, depending on the authority."],
    ],
  },
  {
    id: 13,
    slug: "trademark-registration-guide-pakistan",
    relatedService: "trademark-registration",
    category: "Brand Protection",
    tags: ["Trademark", "IPO Pakistan", "Brand Protection"],
    title: "Why You Should Register Your Trademark Before Someone Else Does",
    metaTitle: "Trademark Registration in Pakistan | IPO-Pakistan Guide",
    metaDescription:
      "Learn how trademark registration with IPO-Pakistan protects your brand name and logo, and why it's worth doing early.",
    keywords: [
      "trademark registration Pakistan",
      "IPO Pakistan trademark",
      "register brand name Pakistan",
      "logo registration Pakistan",
    ],
    excerpt:
      "Your brand name and logo are valuable, and without a registered trademark, someone else could legally use them. Here's why registration matters.",
    image: "goverment.jpeg",
    imageAlt: "Trademark registration certificate and brand protection",
    publishDate: "2026-08-29",
    readTime: "4 min read",
    content: [
      { type: "p", text: "Your brand name and logo are often one of your business's most valuable assets, but without a registered trademark, you don't have full legal protection over them, and someone else could start using something very similar." },
      { type: "h2", text: "What Trademark Registration Protects" },
      { type: "ul", items: [
        "Your business name or brand name",
        "Your logo",
        "Your tagline or slogan, in some cases",
      ]},
      { type: "h2", text: "Why Register Early" },
      { type: "p", text: "Trademarks are registered on a first-come, first-served basis. If a competitor registers a name similar to yours first, you could be the one forced to rebrand, even if you were using the name first without registering it." },
      { type: "h2", text: "How the Process Works" },
      { type: "p", text: "It starts with a trademark search to make sure your name or logo isn't already taken, followed by filing your application with IPO-Pakistan under the correct class of goods or services. If there are no objections, you'll receive your registration certificate." },
      { type: "h2", text: "What You Should Prepare" },
      { type: "ul", items: [
        "The exact brand name, logo, or slogan you want to protect",
        "A clear description of the goods or services you provide",
        "Applicant identity and business registration details",
        "A clear logo file and proof of use when it is relevant to the application",
      ]},
      { type: "h2", text: "What Happens if Someone Objects?" },
      { type: "p", text: "IPO-Pakistan may publish the application for opposition, or an examiner may raise an objection. This does not always mean the application has failed. A timely reply with the right explanation and evidence can keep the application moving." },
      { type: "p", text: "Zawix handles trademark searches, application filing, and follow-up with IPO-Pakistan, so your brand gets the legal protection it deserves." },
    ],
    faqs: [
      ["How long is a trademark valid for?", "Once registered, a trademark is generally valid for 10 years and can be renewed."],
      ["Can I register a trademark before starting my business?", "Yes, you can register a trademark even if it's proposed to be used, which is common for new businesses."],
    ],
  },
];
